export const workspaceTypeData = [
  {
    value: 1,
    label: 'Державна організація',
  },
  {
    value: 2,
    label: 'Індивідуальне підприємство',
  },
  {
    value: 3,
    label: 'Освітня установа',
  },
  {
    value: 4,
    label: 'Партнерство',
  },
  {
    value: 5,
    label: 'Підприємець',
  },
  {
    value: 6,
    label: 'Публічна компанія',
  },
  {
    value: 7,
    label: 'Приватне підприємство',
  },
];
  
export const industryData = [
  {
    value:1,
    label: 'ІT-послуги та ІТ-консалтинг',
    specialization: [
      {
        value: 1,
        label: 'Розробка програмного забезпечення',
      },
    ],
  },
  {
    value:2,
    label: 'Виробництво',
    specialization: [
      {
        value: 1,
        label: 'Автомобілебудування',
      },
    ],
  },
];
  
export const companySizeData = [
  {
    value: 1,
    label: '0-1 співробітник',
  },
  {
    value: 2,
    label: '2-10 співробітників',
  },
  {
    value: 3,
    label: '11-50 співробітників',
  },
  {
    value: 4,
    label: '51-200 співробітників',
  },
  {
    value: 5,
    label: '201-500 співробітників',
  },
  {
    value: 6,
    label: '501-1 000 співробітників',
  },
  {
    value: 7,
    label: '1 001-5 000 співробітників',
  },
  {
    value: 8,
    label: '5 001-10 000 співробітників',
  },
  {
    value: 9,
    label: '10 001+ співробітник',
  },
];